
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { updateSEO, addJSONLD } from '../../utils/seo';

export default function Cooperation() {
  useEffect(() => {
    // Update SEO
    updateSEO({
      title: '合作伙伴 - 南滇古茶战略合作伙伴',
      description: '南滇古茶合作伙伴页面，展示我们与各大茶企、电商平台、物流公司等战略合作伙伴的深度合作关系。',
      keywords: '合作伙伴,战略合作,茶企合作,电商合作,物流合作,供应链合作',
      type: 'website',
      url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/cooperation`
    });

    // Add JSON-LD structured data
    addJSONLD({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "合作伙伴",
      "description": "南滇古茶战略合作伙伴展示",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/cooperation`,
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "首页",
            "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "合作伙伴",
            "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/cooperation`
          }
        ]
      }
    });
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <div className="container mx-auto px-6 py-20">
          <div className="text-center">
            <h1 className="text-3xl md:text-4xl font-bold text-gray-800 mb-6">
              合作伙伴
            </h1>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              我们的合作伙伴页面正在建设中，即将为您展示我们与各大企业的深度合作关系。
            </p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
